<header ng-show="!showLabel || showLabel === 'true'">
    <h1>{{localize(activity.Trigger.FriendlyName)}}</h1>
</header>
<textarea name="activityMessage" class="activity-message" ng-model="activity.Message" ng-attr-placeholder="{{'activityMessagePlaceholder'|translate}}"></textarea>
